import { DATE_SUBMIT_FORMAT } from '../../../Common/settings/dateFormats'
import { IUpdateBlockData } from '../../types'
import { IAPIUpdateBlock } from '../../types/api'

export const updateBlockTransformer = (
  blockData: IUpdateBlockData,
): IAPIUpdateBlock => ({
  starts_at: blockData.startsAt.format(DATE_SUBMIT_FORMAT),
  ends_at: blockData.endsAt.format(DATE_SUBMIT_FORMAT),
  person_uuid: blockData.personUuid,
  blocked_category_uuid: blockData.blockedCategoryUuid,
  notes: blockData.notes,
})
